<template>
  <section class="section-new-arrivals">
    <div class="container">
      <div class="category">
        <div class="category__header">
          <div class="category__title">人気ランキング</div>
          <div class="category__tabs">
            <div
              class="category__tab-item"
              :class="{ active: type == 1 }"
              @click="changeType(1)"
            >胡蝶蘭</div>
            <div
              class="category__tab-item"
              :class="{ active: type == 2 }"
              @click="changeType(2)"
            >観葉植物</div>
            <div
              class="category__tab-item"
              :class="{ active: type == 3 }"
              @click="changeType(3)"
            >アレンジメント</div>
            <div
              class="category__tab-item"
              :class="{ active: type == 4 }"
              @click="changeType(4)"
            >ミディ・マイクロ胡蝶蘭特集</div>
          </div>
        </div>
        <div class="category__body">
          <transition-group
            :duration="{ enter: 2000, leave: 0 }"
            :name="transitionName"
            tag="div"
            class="product-list"
          >
            <ProductItem
              v-for="(product, index) in list"
              :key="product.id"
              :template-number="1"
              :product="product"
              :ranking="rankingCounting(index)"
              location="HomeRecommendedList"
            />
          </transition-group>
          <button type="button" class="slide-button prev" @click="prev" v-if="page != 1"></button>
          <button type="button" class="slide-button next" @click="next" v-if="!maxPage"></button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProductItem from "../ProductItem";

export default {
  components: {
    ProductItem
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      list: [],
      page: 1,
      type: 1,
      transitionName: "fadeLeft",
      maxPage: false
    };
  },
  created: function() {
    this.fetchProducts();
  },
  methods: {
    fetchProducts: async function() {
      this.maxPage = false;

      try {
        const result = await this.$axios.get(this.apiUrl, {
          params: {
            page: this.page,
            type: this.type
          }
        });

        if (result.data.length > 0) {
          this.list = result.data;

          if (result.data.length < 8) {
            this.maxPage = true;
          }
        } else {
          this.maxPage = true;
        }
      } catch (err) {
        console.log("fetching new products list error:", err);
      }
    },
    prev: function() {
      this.transitionName = "fadeRight";
      this.list = [];
      this.page -= 1;

      if (this.page == 1) {
        this.maxPage = false;
      }
      this.fetchProducts();
    },
    next: function() {
      this.transitionName = "fadeLeft";
      this.list = [];
      this.page += 1;

      this.fetchProducts();
    },
    changeType: function(type) {
      this.type = type;
      this.list = [];
      this.page = 1;

      this.fetchProducts();
    },
    rankingCounting: function(index) {
      if (this.page == 1) {
        return index + 1;
      } else {
        return (this.page - 1) * 8 + index + 1;
      }
    }
  }
};
</script>